import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const _getProductCategory = async (queryParamFilters, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/product-category',
    params: params,
  })

  return response?.data
}

export const getProductCategory = (queryParamFilters) => async (queryParam) =>
  await _getProductCategory(queryParamFilters, queryParam)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/product-category/${id}`,
  })

  return response?.data
}
